module.exports = __webpack_public_path__ + "img/BLANCO_Development.659ae226.png";